export default function SafetyComparison() {
  return (
    <section className="relative w-full">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[600px]">
        <div className="relative overflow-hidden bg-background-100">
          <img
            src="https://readdy.ai/api/search-image?query=Bright%20organized%20modern%20warehouse%20interior%20with%20neatly%20stacked%20cardboard%20boxes%20on%20industrial%20shelving%20soft%20natural%20daylight%20streaming%20through%20large%20windows%20clean%20minimalist%20logistics%20aesthetic%20warm%20neutral%20tones%20professional%20commercial%20photography%20peaceful%20orderly%20atmosphere&width=900&height=700&seq=safety-bg-v2&orientation=landscape"
            alt="Bezpieczeństwo Kakobuy"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-transparent to-background-100/60"></div>
          <div className="absolute top-8 left-8">
            <span className="font-label text-xs font-medium text-foreground-600 uppercase tracking-wider">Bezpieczeństwo & Porównanie</span>
          </div>
          <div className="absolute bottom-8 left-8 right-8">
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-none">
              Jak kupować
              <br />
              bezpiecznie i
              <br />
              tanio?
            </h2>
          </div>
        </div>

        <div className="bg-background-50 flex items-center px-8 md:px-14 py-16">
          <div className="w-full max-w-lg mx-auto">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-8">
              Porównaj opcje
              <br />
              i zabezpiecz zakupy
            </h2>

            <div className="overflow-x-auto mb-10">
              <table className="w-full border-collapse">
                <thead>
                  <tr className="border-b border-background-200">
                    <th className="text-left py-3 font-label text-sm font-semibold text-foreground-800">Funkcja</th>
                    <th className="text-center py-3 font-label text-xs font-semibold text-accent-600">
                      <span className="bg-accent-50 px-3 py-1 rounded-full">Kakobuy Spreadsheet</span>
                    </th>
                    <th className="text-center py-3 font-label text-xs font-semibold text-foreground-500">Standardowe wyszukiwanie</th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    { feature: 'Lista produktów', ks: true, sw: false },
                    { feature: 'Kategorie', ks: true, sw: false },
                    { feature: 'QC zdjęcia', ks: true, sw: false },
                    { feature: 'Aktualizacje', ks: true, sw: false },
                    { feature: 'Oszczędność czasu', ks: true, sw: false },
                  ].map((row, i) => (
                    <tr key={i} className="border-b border-background-100">
                      <td className="py-3 font-body text-sm text-foreground-700">{row.feature}</td>
                      <td className="text-center py-3">
                        <i className="ri-check-line text-accent-500 text-lg"></i>
                      </td>
                      <td className="text-center py-3">
                        <i className="ri-close-line text-secondary-500 text-lg"></i>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="bg-accent-50/50 rounded-2xl p-5 mb-8">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-shield-star-line text-accent-600 text-sm"></i>
                </div>
                <div>
                  <h4 className="font-label text-sm font-semibold text-foreground-950 mb-1">Poradnik bezpieczeństwa</h4>
                  <p className="font-body text-sm text-foreground-600 leading-relaxed">
                    Kakobuy Spreadsheet pomaga znaleźć produkty, ale każdy użytkownik powinien samodzielnie sprawdzać sprzedawców, opinie oraz informacje dotyczące wysyłki. Zawsze analizuj QC zdjęcia i porównuj opcje przed zakupem.
                  </p>
                </div>
              </div>
            </div>

            <div className="space-y-3 mb-8">
              {[
                { risk: 'Nieaktualny link', solution: 'Sprawdź aktualną listę' },
                { risk: 'Niska jakość', solution: 'Analizuj QC zdjęcia' },
                { risk: 'Problemy z wysyłką', solution: 'Porównaj opcje dostawy' },
                { risk: 'Brak informacji', solution: 'Czytaj opinie innych' },
              ].map((item, i) => (
                <div key={i} className="flex items-center justify-between p-3 rounded-lg bg-background-100">
                  <div className="flex items-center gap-2">
                    <i className="ri-error-warning-line text-secondary-500 text-sm"></i>
                    <span className="font-body text-sm text-foreground-700">{item.risk}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="font-body text-sm text-accent-600">→ {item.solution}</span>
                  </div>
                </div>
              ))}
            </div>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-label text-sm font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Zobacz Kakobuy Spreadsheet
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}